export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isSnakeCase(str: string) {
  return str.includes("_");
}

export function camelCaseToSnakeCase(str: string) {
  return str.replace(/[\w]([A-Z])/g, (m) => m[0] + "_" + m[1]).toLowerCase();
}

export const pascalCase = (str: string) =>
  str.length > 1
    ? str.charAt(0).toUpperCase() + str.slice(1)
    : str.toUpperCase();

export function camelToSnakeUpperCase(str: string) {
  const _ = str.replace(/([A-Z])/g, `_$1`);
  return _.toUpperCase();
}
